import Vue from "vue";
import Router from "vue-router";
import Homepage from "./components/home/Homepage";
import Search from "@/components/Search";
import LibraryOrders from "@/components/LibraryOrders";
import OrderLimits from "@/components/OrderLimits.vue";
import store from "@/store";
import Reports from "@/components/Reports";
Vue.use(Router);


export default new Router({
    routes: [
        {path: '/', meta:{title:'Αρχική Σελίδα'}, component: Homepage, beforeEnter : checkIfAuthorized},
        {path: '/search', meta:{title:'Αναζήτηση'}, component: Search, beforeEnter : checkIfAuthorized},
        {path: '/orderLimits', meta:{title:'Όρια Παραγγελιών'}, component: OrderLimits, beforeEnter : checkIfAuthorized},
        {path: '/reports', meta:{title:'Αναφορες'}, component: Reports, beforeEnter : checkIfAuthorized},
        {path: '/libraryOrders', meta:{title:'Παραγγελίες Βιβλίων'}, component: LibraryOrders, beforeEnter : checkIfAuthorized},
        
    ]
});
function checkIfAuthorized(to, from, next) {
    if(to.path==='/reports' && store.getters.homePageInformation.bookSupplier.type==='Ministry'){
        // do nothing
    }else  if(to.path==='/orderLimits' && store.getters.homePageInformation.bookSupplier.type==='Library'){
        // do nothing
    }else{
        next();
    }
    
}